import { HHTypography } from '@hinge-health/react-component-library';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

const monoCell = {
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
  fontSize: 13,
  fontVariantNumeric: 'tabular-nums' as const,
};

export interface ConflictField {
  field: string;
  incoming: unknown;
  existing: unknown;
}

interface ConflictTableProps {
  conflicts: ConflictField[];
}

// Three-column diff for conflict-resolution alerts. Used by Merchant
// (per-TIN attribute conflicts) and any other step that needs to show what
// the operator's input disagrees with on an existing record.
export const ConflictTable = ({
  conflicts,
}: ConflictTableProps): JSX.Element => (
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell sx={{ width: 160 }}>Field</TableCell>
        <TableCell sx={{ width: '40%' }}>Incoming</TableCell>
        <TableCell>Existing</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {conflicts.map(c => (
        <TableRow key={c.field}>
          <TableCell sx={{ verticalAlign: 'top' }}>
            <HHTypography hhVariant="body2" sx={{ opacity: 0.75 }}>
              {c.field}
            </HHTypography>
          </TableCell>
          <TableCell sx={{ ...monoCell, color: '#dc3545' }}>
            {String(c.incoming)}
          </TableCell>
          <TableCell sx={monoCell}>{String(c.existing)}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
